import api from './api'

export const aiService = {
  chat: async (payload) => (await api.post('/ai/chat', payload, { timeout: 180000 })).data,
  listSessions: async (q) => (await api.get('/ai/sessions', { params: q ? { q } : {} })).data,
  sessionMessages: async (sessionId) => (await api.get(`/ai/sessions/${sessionId}/messages`)).data,
  updateSession: async (sessionId, payload) => (await api.patch(`/ai/sessions/${sessionId}`, payload)).data,
  deleteSession: async (sessionId) => (await api.delete(`/ai/sessions/${sessionId}`)).data,
  analyzePrices: async (payload) => (await api.post('/ai/analyze-prices', payload, { timeout: 180000 })).data,
  usage: async () => (await api.get('/ai/usage')).data,
  customerSummary: async (customer, company) =>
    (await api.get(`/ai/customer/${encodeURIComponent(customer)}/summary`, { params: { company } })).data,
  refreshNarrative: async (company, customer) =>
    (await api.post('/ai/narrative/refresh', { company, customer }, { timeout: 180000 })).data,
  insights: async (params = {}) => (await api.get('/ai/insights', { params })).data,
  dismissInsight: async (id) => (await api.post(`/ai/insights/${id}/dismiss`)).data,
  rebuildInsights: async () => (await api.post('/ai/insights/rebuild', {}, { timeout: 120000 })).data,
  presetQuestions: async () => (await api.get('/ai/preset-questions')).data,
  segments: async (company) => (await api.get('/ai/segments', { params: { company } })).data,
  segmentDetail: async (segment, company, params = {}) =>
    (await api.get(`/ai/segments/${segment}`, { params: { company, ...params } })).data,
  presetQuestionsAll: async () => (await api.get('/ai/preset-questions/all')).data,
  createPresetQuestion: async (q) => (await api.post('/ai/preset-questions', q)).data,
  updatePresetQuestion: async (id, q) => (await api.put(`/ai/preset-questions/${id}`, q)).data,
  deletePresetQuestion: async (id) => (await api.delete(`/ai/preset-questions/${id}`)).data,
}
